import * as i from 'io-ts';

export const Position3D = i.type({
    x: i.number,
    y: i.number,
    z: i.number,
});

export type Position3D = i.TypeOf<typeof Position3D>;

export const Orientation3D = i.type({ x: i.number, y: i.number, z: i.number, w: i.number });

export type Orientation3D = i.TypeOf<typeof Orientation3D>;

export const Pose = i.type({ position: Position3D, orientation: Orientation3D });

export type Pose = i.TypeOf<typeof Pose>;
